import { Content, Lesson, SllLesson, SllModule } from '@src/types';
import React, { createContext, ReactNode, useCallback, useContext, useState } from 'react';
export type SelectionLevel = 'Lesson' | 'Content' | null;

type StudentLessonContext = {
  sllModule: undefined | SllModule;
  sllLesson: undefined | SllLesson;
  setSllModule: (sllModule: SllModule | undefined) => void;
  setSllLesson: (sllLesson: SllLesson | undefined) => void;
  content: undefined | Content;
  lesson: undefined | Lesson;
  setContent: (content: Content | undefined) => void;
  setLesson: (lesson: Lesson | undefined) => void;
  clear: () => void;
  isPreview?: boolean;
  setIsPreview: (isPreview: boolean) => void;
  pageNumber: number;
  setPageNumber: (pageNumber: number) => void;
  totalPages: number;
  setTotalPages: (totalPages: number) => void;
  lastContent: boolean;
  setLastContent: (lastContent: boolean) => void;
  showExitTicket?: boolean;
  setShowExitTicket: (showExitTicket: boolean) => void;
  showCompleteUnit?: boolean;
  setShowCompleteUnit: (showCompleteUnit: boolean) => void;
  showMaterail?: boolean;
  setShowMaterial: (showMaterial: boolean) => void;
};

const noop = () => {};
const defaultState: StudentLessonContext = {
  sllModule: undefined,
  setSllModule: noop,
  sllLesson: undefined,
  setSllLesson: noop,
  content: undefined,
  setContent: noop,
  lesson: undefined,
  setLesson: noop,
  clear: noop,
  isPreview: false,
  setIsPreview: noop,
  pageNumber: 1,
  setPageNumber: noop,
  totalPages: 0,
  setTotalPages: noop,
  lastContent: false,
  setLastContent: noop,
  showExitTicket: false,
  setShowExitTicket: noop,
  showCompleteUnit: false,
  setShowCompleteUnit: noop,
  showMaterail: false,
  setShowMaterial: noop,
};
const StudentLessonContentContext = createContext(defaultState);

type Props = {
  children: ReactNode;
}

export const StudentLessonProvider = ({ children }: Props) => {
  const [sllModule, setSllModule] = useState<SllModule | undefined>(defaultState.sllModule);
  const [sllLesson, setSllLesson] = useState<SllLesson | undefined>(defaultState.sllLesson);
  const [content, setContent] = useState<Content | undefined>(defaultState.content);
  const [lesson, setLesson] = useState<Lesson | undefined>(defaultState.lesson);
  const [isPreview, setIsPreview] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [lastContent, setLastContent] = useState<boolean>(false);
  const [showExitTicket, setShowExitTicket] = useState<boolean>(false);
  const [showCompleteUnit, setShowCompleteUnit] = useState(false);
  const [showMaterail, setShowMaterial] = useState(false);

  const clear = useCallback(() => {
    setSllModule(undefined);
    setSllLesson(undefined);
  }, []);

  return (
    <StudentLessonContentContext.Provider value={{
      sllModule,
      sllLesson,
      setSllModule,
      setSllLesson,
      content,
      lesson,
      setContent,
      setLesson,
      clear,
      isPreview,
      setIsPreview,
      pageNumber,
      setPageNumber,
      totalPages,
      setTotalPages,
      lastContent,
      setLastContent,
      showExitTicket,
      setShowExitTicket,
      showCompleteUnit,
      setShowCompleteUnit,
      showMaterail,
      setShowMaterial,
    }}>
      {children}
    </StudentLessonContentContext.Provider>
  );
}

export const useStudentLessonContent = () => useContext(StudentLessonContentContext);
